import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router'

import { isActive } from './helpers'
import { useTableOfContents } from '../hooks/useTableOfContents'
import { useEntitlements } from '~/hooks/useEntitlements'

const LinkItem = ({ children, to, isActive }) => (
  <Link
    to={to}
    className={clsx(
      isActive && 'text-consumer-blue dark:text-dark-consumer-blue font-semibold border-l-2 !border-consumer-blue dark:!border-dark-consumer-blue',
      'py-1 px-2 block hover:text-consumer-blue hover:dark:text-dark-consumer-blue border-l-2 border-transparent hover:border-consumer-blue hover:dark:border-dark-consumer-blue'
    )}
  >
    {children}
  </Link>
)

export const TableOfContents = ({ tableOfContents }: { tableOfContents: any[] }) => {
  const currentSection = useTableOfContents(tableOfContents)

  const { sbFooterRemoved } = useEntitlements()

  const { t } = useTranslation()

  const location = useLocation()

  if (!tableOfContents.length) {
    return null
  }

  return (
    <div
      className={clsx(
        'sm:hidden xl:sticky xl:top-0 xl:right-0 xl:-mr-6 xl:block xl:flex-none xl:overflow-y-auto xl:pt-[52px] 2xl:ml-4 xl:px-4 xl:py-[16px] w-[256px]',
        'dark:text-neutral-20',
        sbFooterRemoved ? 'xl:h-[calc(100vh_-_60px)]' : 'xl:h-[calc(100vh_-_100px)]'
      )}
      data-testid="page-navigation"
    >
      <nav aria-labelledby="on-this-page-title" className="w-full">
        <>
          <h2
            id="on-this-page-title"
            className="px-2 py-1 font-medium border-l-2 border-transparent text-body1 font-display"
          >
            {t('consumer.product.tableOfContent.header')}
          </h2>
          <ol role="list" className="w-full mt-2 space-y-3 text-body2">
            {tableOfContents.map(section => (
              <li key={section.id}>
                <h3>
                  <LinkItem to={`${location.search}#${section.id}`} isActive={isActive(section, currentSection)}>
                    {section.title}
                  </LinkItem>
                </h3>
                {section.children.length > 0 && (
                  <ol
                    role="list"
                    className="pl-5 mt-2 space-y-3"
                  >
                    {section.children.map(subSection => (
                      <li key={subSection.id}>
                        <LinkItem to={`${location.search}#${subSection.id}`} isActive={isActive(subSection, currentSection)}>
                          {subSection.title}
                        </LinkItem>

                      </li>
                    ))}
                  </ol>
                )}
              </li>
            ))}
          </ol>
        </>
      </nav>
    </div>
  ) 
}